import { Input } from '@/components/atoms/Input/Input';

interface SearchFieldProps {
  grow?: boolean;
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  searchFn: (searchTerm: string) => void;
}

export const SearchField = ({
  searchTerm,
  setSearchTerm,
  searchFn,
}: SearchFieldProps) => (
  <Input
    placeholder="e.g 'Newcastle' or 'SW1A 1AA'"
    ariaLabel="e.g 'Newcastle' or 'SW1A 1AA'"
    onChange={setSearchTerm}
    value={searchTerm}
    size={'sm'}
    onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === 'Enter') {
        searchFn(searchTerm);
      }
    }}
  />
);
